'use client';

import MuiLink, { LinkProps } from '@mui/material/Link';
import NextLink from 'next/link';
import { ReactNode } from 'react';

export default function Link({
  href = '#',
  newTab = false,
  children,
  ...props
}: {
  href?: string;
  newTab?: boolean;
  children: ReactNode;
} & LinkProps) {
  return (
    <MuiLink component={NextLink} href={href} target={newTab ? '_blank' : '_self'} {...props}>
      {children}
    </MuiLink>
  );
}
